'use client';
import React from 'react';
import Slider from 'react-slick';
import CasestudyCarouselItem from '../home/casestudy-carousel-item';

const CaseStudies: React.FC = () => {
    const testimonialsettings = {
        dots: true,
        arrow: true,
        autoplay: false,
        speed: 500, // Set slide transition speed
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };
    return (
        <>
            <section className="section-py case-study">
                <div className="container lg:container md:mx-auto">
                    <div className="row flex flex-wrap">
                        <div>
                            <h2
                                className="mb-2.5 text-textcolor dark:text-white"
                                data-aos="fade-up"
                                data-aos-duration={1000}
                                data-aos-delay={100}
                            >
                                Case Studies
                            </h2>
                            <p
                                className="mb-50 text-textcolor dark:text-white"
                                data-aos="fade-up"
                                data-aos-duration={1000}
                                data-aos-delay={200}
                            >
                                Before deciding on whether we can help transform your business, we recommend checking out our case
                                studies for more information.
                            </p>
                        </div>
                    </div>

                    <div className="section pb-16 dark:bg-black case-study-slider-img">
                        <div className="container-fluid lg:container-fluid mx-auto">
                            <Slider {...testimonialsettings} data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                                <CasestudyCarouselItem
                                    path={'/img/case-study/img-casestudy-erp-2x.webp'}
                                    height={400}
                                    width={630}
                                    alt="case-study"
                                    title="case-study"
                                    data="Odoo Implementation, Customization, and User Training for tailored Web Portal and Mobile/Tablet App Solutions."
                                    name="ERP Implementation for Furniture Manufacturer and Trader"
                                    link="/case-studies/pashwa-case-study"
                                />
                                <CasestudyCarouselItem
                                    path={'/img/case-study/img-casestudy-ondemand-2x.webp'}
                                    height={400}
                                    width={630}
                                    alt="case-study"
                                    title="case-study"
                                    data="We crafted an amazing On-demand cleaning booking services platform for a startup. Our solution connects homeowners with trusted professional cleaners, transforming the way cleaning is done."
                                    name="On-demand Cleaning Booking Services Platform"
                                    link="/case-studies/on-demand-cleaning-booking-services-platform"
                                />
                                <CasestudyCarouselItem
                                    path={'/img/case-study/img-casestudy-allinone-2x.webp'}
                                    height={400}
                                    width={630}
                                    alt="case-study"
                                    title="case-study"
                                    data="We created an All-in-one Resort Management platform, carefully designed to make resort operations smoother and more profitable, providing guests with a seamless experience."
                                    name="All-in-one Online Resort Management Platform"
                                    link="/case-studies/all-in-one-online-resort-management-platform"
                                />
                                <CasestudyCarouselItem
                                    path={'/img/case-study/img-casestudy-subscription-2x.webp'}
                                    height={400}
                                    width={630}
                                    alt="case-study"
                                    title="case-study"
                                    data="We developed a subscription-based online discount platform that offers subscribers exclusive discounts, deals and offers from various restaurant chains and online retailers."
                                    name="Subscription-based Online Discount Platform"
                                    link="/case-studies/subscription-based-online-discount-platform"
                                />
                            </Slider>
                        </div>
                    </div>

                    {/* <div className="row grid md:grid-cols-3">
        <CaseStudyItem
          videoUrl="./media/project-stevie.mp4"
          thumbnail="/img/img-enjoy-stevie@2x.webp"
          alt="Subscription-based Online Discount Platform"
          csTitle="Subscription-based Online Discount Platform"
          para="We developed a subscription-based online discount platform that offers subscribers
            exclusive discounts, deals and offers from various restaurant chains and online 
            retailers."
          url={'/case-studies/subscription-based-online-discount-platform'}
          isButton={true} />
        <CaseStudyItem
          videoUrl="./media/project-navdeep-resort.mp4"
          thumbnail="/img/img-navdeep-resort@2x.webp"
          alt="All-in-one Online Resort Management Platform"
          csTitle="All-in-one Online Resort Management Platform"
          para="We created an All-in-one Resort Management platform, carefully designed to make
            resort operations smoother and more profitable, providing guests with a seamless 
            experience."
          url={'/case-studies/all-in-one-online-resort-management-platform'}
          isButton={true} />
        <CaseStudyItem
          videoUrl="./media/project-cleannow.mp4"
          thumbnail="/img/img-cleannow@2x.webp"
          alt="On-demand Cleaning Booking Services Platform"
          csTitle="On-demand Cleaning Booking Services Platform"
          para="We crafted an amazing On-demand cleaning booking services platform for a startup.
            Our solution connects homeowners with trusted professional cleaners, transforming 
            the way cleaning is done."
          url={'/case-studies/on-demand-cleaning-booking-services-platform'}
          isButton={true} />
        <div className="col-span-full text-center">
          <Link href="/case-studies" className="btn btn-primary">
          View All Case Studies
          </Link>
        </div>
      </div> */}
                </div>
            </section>
        </>
    );
};
export default CaseStudies;
